import { render, staticRenderFns } from "./BusSec.vue?vue&type=template&id=86af0136&"
import script from "./BusSec.vue?vue&type=script&lang=js&"
export * from "./BusSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports